module.exports = __webpack_public_path__ + "media/images/official/special_hopper_01-ee174ce197faac040fe0e25f62a7166e.jpg";